import { Button } from "./Button";
import { Icon } from "./Icon";

export function LoadingState({ label }: { readonly label: string }) {
  return (
    <div className="state-view" role="status" aria-live="polite">
      <span className="logo-loader" aria-hidden="true">
        <img className="logo-loader__mark" src="/assets/icons/athkari-logo.svg" alt="" />
      </span>
      <p>{label}</p>
    </div>
  );
}

export function ErrorState({ title, message, onRetry }: { readonly title: string; readonly message: string; readonly onRetry?: () => void }) {
  return (
    <div className="state-view state-view--error" role="alert">
      <Icon name="warning" className="icon icon--lg" />
      <h3>{title}</h3>
      <p>{message}</p>
      {onRetry ? <Button type="button" onClick={onRetry}>{title}</Button> : null}
    </div>
  );
}

export function EmptyState({ title, message }: { readonly title: string; readonly message: string }) {
  return (
    <div className="state-view">
      <Icon name="search" className="icon icon--lg" />
      <h3>{title}</h3>
      <p>{message}</p>
    </div>
  );
}
